export default "__VITE_ASSET__l7JGvc$T__"